<template>
  <div class="root">
    <div v-if="countSocials" class="social-head">
      <button @click="hidden = !hidden" class="social-button">
        <img v-if="hidden" src="../../files/plus-icon.svg" alt="plus-icon" />
        <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
      </button>
      <p v-if="countSocials" class="social-head-title">Селитебные объекты ({{ countSocials }})</p>
    </div>

    <ul
      :class="[
        'social-list',
        {
          'social-list_hidden': hidden,
        },
      ]"
      v-if="socials && socials.length > 0"
    >
      <li class="social-list-item" v-for="(social, socialIndex) in socials" :key="social.id">
        <div class="social-item">
          <div class="social-item-icon-block">
            <div class="social-icon-wrapper">
              <img
                draggable="false"
                :src="getImage(social.type)"
                :class="[
                  'social-icon-image',
                  {
                    'social-icon_disabled': social.exclude && parseInt(social.exclude) != 0,
                  },
                ]"
              />
              <!-- Иконка исключенного из расчета -->
              <img
                src="../../assets/icons/disabled-icon.svg"
                v-if="social.exclude && parseInt(social.exclude) != 0"
                class="social-exclude-icon"
              />
            </div>
          </div>

          <span :style="{ 'background-color': social.color }" class="submenu-piplene-label">{{
            social.icon_text
          }}</span>

          <div class="submenu-piplenes">
            <span class="submenu-map-objects-text black"> {{ social.name }} </span>

            <span v-if="social.type == 1 || social.type == 2" class="submenu-map-objects-text"
              >Кол-во человек: <span class="black">{{ social.count_of_persons }}</span>
            </span>

            <span v-if="social.type == 2" class="submenu-map-objects-text"
              >Количество часов: <span class="black">{{ social.hours }}</span>
            </span>

            <span v-if="social.type == 3 || social.type == 4" class="submenu-map-objects-text"
              >Интенсивность движения: <span class="black">{{ social.intensity }}</span>
            </span>

            <span v-if="social.type == 3 || social.type == 4" class="submenu-map-objects-text"
              >Скорость движения, км\ч: <span class="black">{{ social.speed }}</span>
            </span>

            <span
              v-if="
                project.result &&
                project.result.residential &&
                project.result.residential[social.id] &&
                project.result.residential[social.id].ind_risk
              "
              class="submenu-map-objects-text"
              >Инд. риск: <span class="black" v-html="toNormal(project.result.residential[social.id].ind_risk)" />
            </span>

            <span
              v-if="
                project.result &&
                project.result.residential &&
                project.result.residential[social.id] &&
                project.result.residential[social.id].risk
              "
              class="submenu-map-objects-text"
              >Соц. риск: <span class="black" v-html="toNormal(project.result.residential[social.id].risk)" />
            </span>
          </div>

          <!-- Контекстное меню -->
          <social-dropdown
            :handleDropdownClick="handleDropdownClick"
            :shiftY="shiftY"
            @onFullTurnOff="turnOff(social.id, socialIndex)"
            @onEditClick="handleEditSocial(social, socialIndex)"
            @onRemoveClick="handleSocialDelete(social, socialIndex)"
            :social="social"
          />
        </div>
      </li>
    </ul>

    <b-modal ref="socialEdit" id="socialEdit" hide-footer title="Изменить объект на прилегающей территории">
      <socialEdit
        @socialEditHide="editSocials(); $emit('clearCalculations')"
        @socialCreated="$refs.socialEdit.hide()"
        :project="project"
        :cur_index="curIndex"
        :social="curSocial"
        :socials.sync="socials"
      />
    </b-modal>

    <confirm-modal
      id="socialRemoveModal"
      title="Удалить"
      content="Вы действительно хотите удалить этот жилой объект?"
      @onSubmitClick="removeSocial()"
    />

    <!-- Выбор селитебного объекта -->
    <modal-wrapper
      @onCancelClick="$bvModal.hide('socialTypeModal')"
      dialogClass="add-social-modal"
      hide-footer
      modalId="socialTypeModal"
      title="Тип объекта"
    >
      <div class="add-social-grid">
        <div
          @click="
            step = 2;
            socialAdd(option.value);
          "
          :key="option.value"
          v-for="option in options"
          class="add-installation-card"
        >
          <img :src="option.image" alt="icon" />
          <p>{{ option.text }}</p>
        </div>
      </div>
    </modal-wrapper>
  </div>
</template>

<script>
import SocialDropdown from "./components/SocialDropdown";
import socialEdit from "../../views/risks/mapEditor/socialEdit";
import { handleInstallationDropdownClick } from "../../utils/utils";
import ModalWrapper from "../modals/ModalWrapper.vue";
import ConfirmModal from "../modals/ConfirmModal.vue";

export default {
  components: { SocialDropdown, socialEdit, ModalWrapper, ConfirmModal },
  props: {
    socials: Array,
    project: Object,
    legalResIndRisk: Number,
    legalResSocRisk: Number,
    temp: Object, // используется для передачи в родительский компонент данных для редактировании
  },
  data() {
    return {
      hidden: false,
      shiftY: 0,
      curSocial: {},
      curIndex: null,
      type: 1,
      options: [
        { value: 1, text: "Жилое здание", image: require("../../assets/icons/residential_facilities.svg") },
        { value: 2, text: "Общественное здание", image: require("../../assets/icons/public_building.svg") },
        { value: 3, text: "Автодорога", image: require("../../assets/icons/road.svg") },
        { value: 4, text: "Железная дорога", image: require("../../assets/icons/railway.svg") },
      ],
    };
  },
  computed: {
    countSocials() {
      return (this.socials && this.socials.length) || 0;
    },
  },

  methods: {
    handleDropdownClick(event) {
      this.shiftY = handleInstallationDropdownClick(event, 180);
    },

    getImage(type) {
      switch (String(type)) {
        case "1":
          return require("../../assets/icons/residential_facilities.svg");
        case "2":
          return require("../../assets/icons/public_building.svg");
        case "3":
          return require("../../assets/icons/road.svg");
        case "4":
          return require("../../assets/icons/railway.svg");
      }
    },

    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "⋅10<sup>-" + val[1] + "</sup>";
      } else {
        val = String(val);
        var multiply = 0;
        for (var i in val) {
          if (val[i] == "0" || val[i] == ".") {
            multiply++;
          } else {
            break;
          }
        }
        if (multiply > 1) {
          val = val * Math.pow(10, multiply - 1);
          parseFloat(val).toFixed(2);
          return Math.floor(val * 100) / 100 + "⋅10<sup>-" + (multiply - 1) + "</sup>";
        } else {
          return parseInt(val).toFixed(2);
        }
      }
    },

    turnOff(socialId, index) {
      this.$http
        .post("risk/socials/exclude?proj_id=" + this.project.id + "&id=" + socialId)
        .then((response) => {
          this.$set(this.socials[index], "exclude", response.data);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },

    handleEditSocial(social, index) {
      this.curSocial = Object.assign({}, social);
      this.curIndex = index;

      this.$bvModal.show("socialEdit");
    },

    editSocials() {
      this.$emit("socialEdit");
      this.$refs.socialEdit.hide();
    },

    handleSocialDelete(social, index) {
      this.curSocial = Object.assign(this.curSocial, social);
      this.curIndex = index;

      this.$bvModal.show("socialRemoveModal");
    },

    removeSocial() {
      this.$http
        .post("risk/socials/remove?proj_id=" + this.project.id + "&id=" + this.curSocial.id)
        .then(() => {
          this.socials.splice(this.curIndex, 1);
          this.$bvModal.hide("socialRemoveModal");
        })
        .catch((e) => {
          console.error(e);
        });
    },

    socialAdd(type) {
      this.$bvModal.hide("socialTypeModal");
      this.$set(this.temp, "type", type);
      this.$emit("update:action", "socialAdd");

      if (type == 1 || type == 2) {
        this.$bvToast.show("new-social-toast");
      }
      if (type == 3 || type == 4) {
        this.$bvToast.show("new-road-toast");
      }
    },
  },
};
</script>

<style scoped>
.root {
  margin-top: 16px;
}
.social-head {
  display: flex;
  align-items: center;
  gap: 4px;
}
.social-button {
  border: none;
  padding: 0;
  background: transparent;
}
.social-list-item {
  position: relative;
  margin-bottom: 8px;
}
.social-head-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--black-color);
  margin: 0;
}
.social-item-icon-block {
  position: relative;
  z-index: 1;
}
.social-icon-wrapper {
  position: relative;
  width: max-content;
}
.social-icon-image {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
}
.social-exclude-icon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.social-badge {
  min-width: 35px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: -2px;
  padding: 0px 4px;
  border-radius: 20px;
  background: var(--additional-color);
  pointer-events: none;
}
.social-badge-text {
  margin: 0;
  color: var(--white-color);
  font-size: 6px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
}
.social-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.social-item-error-button {
  background: transparent;
  border: none;
}
.social-item-name {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: var(--black-color);
  margin: 0;
  flex-grow: 1;
  display: flex;
}
.social-list {
  margin-top: 8px;
  padding-left: 8px;
  max-height: 100%;
  overflow: auto;
}

.social-list_hidden {
  max-height: 0;
  overflow: hidden;
}

.submenu-map-objects {
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 0;
  overflow: hidden;
}
.submenu-map-objects_opened {
  max-height: 1000px;
  padding-top: 7px;
}

.submenu-map-objects-text {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--grey-3-color);
  margin-left: 4px;
  flex-grow: 1;
}

.submenu-piplenes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 0;
  flex-grow: 1;
}
.submenu-piplene-label {
  position: relative;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0 4px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  color: var(--white-color);
}

.social-icon_disabled {
  opacity: 0.5;
}

.add-social-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 0 24px 24px;
}
</style>
